module.exports = __webpack_public_path__ + "static/media/none_resource.4763a01b.png";